import { VDATable } from '../../../../models/VDAModel';
import { isEmpty } from 'lodash';
import { DATASETS } from '../../../Constants';

const baseLink = 'https://www.ncbi.nlm.nih.gov/';

function openEntityInfoPanel(entityView: string, item: Record<string, any>) {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(
    new CustomEvent('disgenet:open-left-info-panel', {
      detail: { item: { ...item, entityView } },
    }),
  );
}

function getGeneNCBIid(geneNcbiID) {
  return (
    <>
      {!isEmpty(geneNcbiID) && (
        <button
          type="button"
          className="tab-links border-0 bg-transparent p-0"
          onClick={() => openEntityInfoPanel(DATASETS.GENES, { id: geneNcbiID, geneID: geneNcbiID })}
        >
          {geneNcbiID}
        </button>
      )}
    </>
  );
}
//
function getDiseaseLink(row) {
  const vdaData = new VDATable(row);
  const disease = vdaData.diseaseUMLSCUI;
  return (
    <button
      type="button"
      className="tab-links border-0 bg-transparent p-0"
      onClick={() =>
        openEntityInfoPanel(DATASETS.DISEASES, {
          id: vdaData.diseaseUMLSCUI,
          diseaseID: vdaData.diseaseUMLSCUI,
        })
      }
    >
      {disease}
    </button>
  );
}

function getDiseaseName(row) {
  return (
    <button
      type="button"
      className="tab-links border-0 bg-transparent p-0"
      onClick={() =>
        openEntityInfoPanel(DATASETS.DISEASES, {
          id: row.data.diseaseUMLSCUI,
          diseaseID: row.data.diseaseUMLSCUI,
          name: row.data.diseaseName,
        })
      }
    >
      {row.data.diseaseName}
    </button>
  );
}

function getDisease(row) {
  return (
    <button
      type="button"
      className="tab-links border-0 bg-transparent p-0"
      onClick={() =>
        openEntityInfoPanel(DATASETS.DISEASES, {
          id: row.data.diseaseUMLSCUI,
          diseaseID: row.data.diseaseUMLSCUI,
          name: row.data.name,
        })
      }
    >
      {row.data.name}
    </button>
  );
}

function getPmidLink(pmid) {
  const pmidLink = `${baseLink}pubmed/${pmid}`;
  return (
    <a href={pmidLink} target="_blank" rel="noopener noreferrer" className="tab-links">
      {pmid} <i className="fa fa-external-link" aria-hidden="true"></i>
    </a>
  );
}

function variantLink(variant) {
  return (
    <button
      type="button"
      className="tab-links border-0 bg-transparent p-0"
      onClick={() => openEntityInfoPanel(DATASETS.VARIANTS, { id: variant, strID: variant })}
    >
      {variant}
    </button>
  );
}

function referenceLink(variant) {
  const baseUrl = 'https://pubmed.ncbi.nlm.nih.gov/';
  const variantNumber = variant.replace(/\D/g, '');
  const variantUrl = `${baseUrl}${variantNumber}`;
  return (
    <a href={variantUrl} target="_blank" rel="noopener noreferrer" className="tab-links">
      {variant} <i className="fa fa-external-link" aria-hidden="true"></i>
    </a>
  );
}

function getNctidLink(nctid) {
  const baseUrl = 'https://clinicaltrials.gov/search?id=';
  const nctidUrl = `${baseUrl}${nctid}`;
  return (
    <a href={nctidUrl} target="_blank" rel="noopener noreferrer" className="tab-links">
      {nctid} <i className="fa fa-external-link" aria-hidden="true"></i>
    </a>
  );
}

export {
  getDisease,
  getPmidLink,
  getGeneNCBIid,
  getDiseaseLink,
  getDiseaseName,
  variantLink,
  getNctidLink,
  referenceLink,
};
